/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';
import VolleyballSlides from 'pages/components/VolleyballSlides';
import PickleballSlides from 'pages/components/PickleballSlides';
import OutdoorSlides from 'pages/components/OutdoorSlides';
import TaichiSlides from 'pages/components/TaichiSlides';
import ActivityComponents from 'pages/components/ActivityComponents';
import ScheduleComponents from 'pages/components/ScheduleComponents';
// Wimss context
import { useWimssController, setCurrentTab, setCurrentSlides } from 'context';

function WimssTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ maxWidth: '100%', height: 'auto' }}>{children}</Box>
      )}
    </div>
  );
}

WimssTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function WimssTabs({ tabs }) {
  const [controller, dispatch] = useWimssController();
  const { currentTab, currentPage } = controller;
  const [value, setValue] = useState(currentTab);

  useEffect(() => {
    if (value === 0) setCurrentSlides(dispatch, VolleyballSlides);
    if (value === 1) setCurrentSlides(dispatch, PickleballSlides);
    if (value === 2) setCurrentSlides(dispatch, OutdoorSlides);
    if (value === 3) setCurrentSlides(dispatch, TaichiSlides);
  }, [value]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentTab(dispatch, newValue);
    if (value === 0) setCurrentSlides(dispatch, VolleyballSlides);
    if (value === 1) setCurrentSlides(dispatch, PickleballSlides);
    if (value === 2) setCurrentSlides(dispatch, OutdoorSlides);
    if (value === 3) setCurrentSlides(dispatch, TaichiSlides);
  };

  return (
    <Box sx={{ width: '100%', height: 'max-content' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='activity tabs'
          spacing={2}
          centered
          sx={{
            '& button': {
              borderRadius: 2,
            },
            '& button:hover': { borderColor: 'grey', border: 1 },
            '& button.Mui-selected, & button:focus': {
              backgroundImage:
                'linear-gradient(to bottom, rgb(255,255,255,0),rgb(191,216,255,0.6))',
            },
          }}>
          {tabs.map(({ icon }, i) => (
            <Tab icon={icon} key={i} {...a11yProps(i)} />
          ))}
        </Tabs>
      </Box>
      {tabs.map(({ Component }, i) => (
        <WimssTabPanel value={value} index={i} key={i}>
          {/* {Component} */}
          {currentPage === 'activities' ? (
            <ActivityComponents />
          ) : (
            <ScheduleComponents />
          )}
        </WimssTabPanel>
      ))}
    </Box>
  );
}
